import { AfterViewChecked, AfterViewInit, Component, EventEmitter, Injector, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';
import { Google_map } from 'src/app/shared/google_map';
import { Kmlmanager } from 'src/app/shared/kmlmanager';
import { Geoutil } from 'src/app/shared/geoutil';
import { Colorutil } from 'src/app/shared/colorutils';
import { LocalizedString } from '@angular/compiler';
import { ILatLng, IContourdefinition, IScenarioLayout } from '../../../shared/geointerfaces'
import { json } from 'd3';

@Component({
  selector: 'app-scenariolayout',
  templateUrl: './scenariolayout.component.html',
  styleUrls: ['./scenariolayout.component.css']
})
export class ScenariolayoutComponent extends BaseComponent implements OnInit {
  @ViewChild('pagemap2', { static: true }) mapElement: any = {}
  @Output() saveScenario = new EventEmitter();
  scenario: any = {}
  layout: any = {}
  scenarios: any = []
  showTabGPS = false
  actionid = 0
  actions: any = []
  standardscenarios: any = []
  standardscenarioid = 0
  showLoadFile = false
  showKMLInfo = false
  fileName = ""
  showChooseNewCenter = false
  copyscenarioid = 0
  scenariosensors: any = []
  google_map: Google_map
  organizations: any = []
  viewObjects = false
  choosePolygonCorner = false
  polygon: any = []
  markers: any = []
  nContours = 5

  constructor(injector: Injector) { super(injector) }

  async ngOnInit() {
    this.initializeDropdownArrays()
    this.organizations = await this.db.get("organization", "getOrganizations")
    const resp = await this.db.get("scenario", "getscenarios")
    this.scenarios = []
    let organizationId = sessionStorage.getItem('organizationId');
    resp.forEach((s: any) => {
      if (s.organizationId.toString() == organizationId) this.scenarios.push(s)
    })
  }

  initialize(scenario: any, layout: any) {
    this.scenario = scenario
    this.layout = layout
    this.showMap()
  }

  actionHasChanged($event: any) {
    // the boolean values determine whether the click on map event is served
    // move center
    this.showChooseNewCenter = $event == 3 ? true : false 

    // to draw polygons
    this.choosePolygonCorner = $event == 6 ? true : false
  }

  clearScenario() {
    this.layout = { center: { lat: 35.2271, lng: -80.8431 }, contours: [], contourdefinitions: [] }
    this.standardscenarioid = 4
    this.selectStandardScenario()
    this.showMap()
    this.saveScenario.emit(this.layout)
    this.actionid = 3
    this.actionHasChanged(3)
  }

  receiveFileAsString($event: any) {
    this.fileName = $event.fileName
    this.scenario.kmlstring = $event.fileData
    let KML = new Kmlmanager($event.fileData)
    this.layout = KML.scenariolayout
    this.layout.contourdefinitions.reverse()
    this.layout.contours.reverse()
    this.scenario.geometryJson = JSON.stringify(this.layout);
    this.showLoadFile = false;
    this.showKMLInfo = true;
    this.showMap();
    this.saveScenario.emit(this.layout)
  }


  async createNewScenario() {
    this.scenario = this.scenarios[0] //take the first scenario
    const now = new Date();

    this.scenario.name = "New Scenario " + now.toLocaleDateString()
    this.scenario.description = "New Scenario " + now.toLocaleDateString()
    this.layout = { center: { lat: 35.2271, lng: -80.8431 }, contours: [], contourdefinitions: [] }

    this.scenariosensors = [];
    await this.db.delete("scenariosensor", "deleteScenarioSensorsByScenId", { scenarioId: this.scenario.id })
    let sensor = { id: 1 }
    await this.addSensorToScenarioSensors(sensor)
    this.standardscenarioid = 4
    this.selectStandardScenario()
  }
  async addSensorToScenarioSensors(sensor: any) {
    let ssnew = this.scenariosensors.find((ss: any) => ss.sensorId == sensor.id)
    if (ssnew == null) {
      ssnew = { id: 0, sensorId: sensor.id, scenarioid: this.scenario.id, seqno: 10, gpsMaxReading: 50 }
      await this.db.post("scenariosensor", "postScenarioSensor", ssnew)
      this.scenariosensors = await this.db.get("scenariosensor", "getscenariosensorsbyscen", { scenarioid: this.scenario.id })
    } else {
      this.toast.info("This sensor is already selected!")
    }
  }

  selectStandardScenario() {
    if (this.standardscenarioid > 0) {
      let standDef = this.standardscenarios.find((x: any) => x.id == this.standardscenarioid)
      if (this.layout != null) {
        this.layout.contours = []
        this.layout.contourdefinitions = []
      }

      for (let i = 1; i <= standDef.nCircles; i++) {
        let radius = i / standDef.nCircles * standDef.radius
        let circle = Geoutil.getCircleArray(this.layout.center, radius, 24)
        this.layout.contours.push(circle);
      }

      this.createContourColors()
      this.showMap()
      this.saveScenario.emit(this.layout)
    }
    else {
      //this.alert.warning("Please, choose a standard scenario first!");
    }
  }
  
  createContourColors(){
    this.layout.contourdefinitions = []
    let nContours = this.layout.contours.length
    let colors = Colorutil.generateColorPalette({ r: 255, g: 0, b: 0 }, { r: 255, g: 255, b: 0 }, nContours)
    for (let i = 0; i < nContours; i++) {
      let exposure = 100 - i / (nContours - 1) * 100;
      this.layout.contourdefinitions.push({ color: colors[i], exposure: exposure });
    }
  }

  async copyFromScenario() {
    let ccscenario = await this.db.get("scenario", "getscenario", { id: this.copyscenarioid });
    this.scenario.geometryJson = ccscenario.geometryJson
    this.layout = JSON.parse(this.scenario.geometryJson)
    this.showMap()
  }

  initializeDropdownArrays() {
    this.actions = [
      { id: 0, name: "" },
      { id: 1, name: "Start fresh" },
      { id: 2, name: "Load KML file" },
      { id: 3, name: "Move center" },
      { id: 4, name: "Select standard scenario" },
      { id: 5, name: "Copy from other scenario" },
      { id: 6, name: "Draw the contour" }
    ]
    this.standardscenarios = [
      { id: 1, name: "5 circles 100m radius", nCircles: 5, radius: 100 },
      { id: 2, name: "5 circles 500m radius", nCircles: 5, radius: 500 },
      { id: 3, name: "5 circles 1000m radius", nCircles: 5, radius: 1000 },
      { id: 4, name: "15 circles 100m radius", nCircles: 15, radius: 100 },
      { id: 5, name: "50 circles 100m radius", nCircles: 50, radius: 100 }
    ];
  }

  repositionScenario(oldCenter: any, newCenter: any) {
    let difLat = newCenter.lat - oldCenter.lat
    let difLng = newCenter.lng - oldCenter.lng
    this.layout.contours.forEach((c: any) => {
      c.forEach((p: any) => {
        p.lat += difLat
        p.lng += difLng
      })
    })
  }

  completePolygon() {
    this.google_map.removePolygon()
    this.markers.forEach((marker: any) => {
      this.google_map.removeMarkers(marker);
    });

    let polys:any = []
    for (let i = 1; i <= this.nContours; i++) {
      let scalingFactor = (i * 1.0)/(this.nContours*1.0)
      let poly = [];
      this.polygon.forEach((p: any) => {
        
        let pScaled = Geoutil.interpolate(p,this.layout.center,scalingFactor)
        poly.push(pScaled);
      });
      let pScaled =  Geoutil.interpolate(this.polygon[0],this.layout.center,scalingFactor)
      poly.push(pScaled);
      
      this.google_map.addPolygon(poly);
      polys.push(poly)
    }
    this.layout.contours = polys
    this.createContourColors()
    this.saveScenario.emit(this.layout);
  }


  removepoint(p: any) {
  }

  clearPolygon() {
    this.polygon = []
    this.google_map.removePolygon()
  }

  showMap() {
    this.google_map = new Google_map()
    let latlng = this.layout.center
    let zoom = this.getZoom()
    this.google_map.init(this.mapElement.nativeElement, latlng, zoom);
    this.layout.contours.forEach((p: any, i: number) => {
      let color = this.layout.contourdefinitions[i].color;
      this.google_map.addPolygon(p, color)
    })

    this.google_map.clickOnMap((res: any) => {
      let latlng = res.latLng.toJSON();

      if (this.showChooseNewCenter == true) {
        let oldCenter = this.layout.center != null ? this.layout.center : null
        this.layout.center = latlng
        //this.showChooseNewCenter = false

        if (oldCenter != null) {
          this.repositionScenario(oldCenter, latlng)
          this.showMap()
        }
        this.saveScenario.emit(this.layout)
      };

      if (this.choosePolygonCorner == true) {
        let latlng = res.latLng.toJSON();
        this.polygon.push(latlng);
        let marker = this.google_map.setMarkerIcon(latlng, "Poly");
        this.markers.push(marker);
      }

    })
  }

  getZoom() {
    let result = 15
    let min = 0
    let max = 0
    if (this.layout.contours.length > 0) {
      min = this.layout.contours[0][0].lat
      max = this.layout.contours[0][0].lat
      this.layout.contours.forEach((c: any) => {
        c.forEach((ll: any) => {
          if (ll.lat < min) min = ll.lat
          if (ll.lat > max) max = ll.lat
        })
      })
      let diff = max - min
      if (diff < 0.010) result = 17
      if (diff < 0.002) result = 18
    }
    return result
  }
}
